<template>
  <div id="login">
    <el-container class="page_login">
      <el-main class="login_min">
        <div class="xueming">
          <!-- <img
            style="width: 380px"
            src="../assets/img/logoT.png"
            alt=""
            srcset=""
          /> -->
          联盟校管理后台
        </div>
        <!-- 登录卡片区域 -->
        <el-card class="box_card" style="padding: 0px">
          <div class="card_content">
            <!-- <div class="content_left"></div> -->
            <div class="content_right">
              <!-- 右侧上部 -->
              <div class="content_right_top">联盟后台登录</div>
              <!-- 右侧下部表单区域 -->
              <el-form
                class="form_login"
                ref="ruleForm"
                :model="ruleForm"
                :rules="formRiles"
              >
                <el-form-item prop="name">
                  <i class="iconp"
                    ><img src="../assets/img/shengfeng.png" alt="" srcset="" />
                  </i>
                  <el-input
                    name="account"
                    v-model.trim="ruleForm.name"
                    placeholder="请输入用户名"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <i class="iconp"
                    ><img src="../assets/img/mima.png" alt="" srcset="" />
                  </i>
                  <el-input
                    v-model.trim="ruleForm.password"
                    type="password"
                    placeholder="请输入密码"
                    show-password
                    @keyup.enter.native="submitForm()"
                  ></el-input>
                </el-form-item>
                <el-button type="primary" @click="submitForm">登录</el-button>
              </el-form>
            </div>
          </div>
        </el-card>
      </el-main>
      <!-- <el-footer>
        <div class="szjy">
          <div class="szjy_left"></div>
          <div class="szjy_content">开启素质教育美好新生态</div>
          <div class="szjy_right"></div>
        </div>
        <foo-ter></foo-ter>
      </el-footer> -->
    </el-container>
  </div>
</template>
<script>
// import fooTer from "./footer/footer";
import { userlogin } from "@/api/home";
export default {
  //   components: {
  //     fooTer,
  //   },
  data() {
    return {
      // 表单输入值
      ruleForm: {
        region: "group",
        name: "",
        password: "",
      },
      //   token
      token: "",
      //   表单验证
      formRiles: {
        region: [{ required: true, message: "请选择身份", trigger: "change" }],
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      flag: false,
    };
  },
  created() {
    // this.submitForm();
  },
  methods: {
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.formHandler();
        } else {
          return false;
        }
      });
    },
    async formHandler() {
      try {
        const { data: res } = await userlogin({
          roleType: this.ruleForm.region,
          account: this.ruleForm.name,
          password: this.ruleForm.password,
        });
        if (res.code == 0) {
          // 添加token到localStorage
          window.localStorage.setItem("token", res.data.token);
          window.localStorage.setItem("roleId", '-1009');
          this.$router.push('/unIndex')
        }else{
            this.$message.error(res.msg);
        }

      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}
#login {
  /* background-color: red; */

  height: 100%;
  width: 100%;
}

.page_login {
  background-color: #f0f2f5;
  width: 100%;
  height: 100vh;
}

.el-main {
  /* background-image: url("../assets/img/bg_image.png"); */
  background-color: #2d84db;
  background-repeat: no-repeat;
  background-size: cover;
  page-break-after: auto;
  position: relative;
}

/* 卡片区域样式 */

.box_card {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 20px;
}

.card_content {
  padding-top: 35px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
}

.card_content .content_right {
  margin: 30px auto;
}

.content_right_top {
  height: 80px;
  font-size: 40px;
  color: #4887ff;
  letter-spacing: 23px;
  padding-left: 20px;
  /* background: #fff url('../../assets/img/login/right-top-text.png'); */
}

.content_right .form_login {
  margin: 20px;
}

.el-scrollbar__view {
  padding: 10px;
}

.form_select {
  width: 100%;
  margin-top: 20px;
}

.form_select_select {
  width: 360px;
}

.el-select-dropdown__item {
  padding-left: 10px;
  width: 360px;
}

.form_login .el-form-item {
  margin-bottom: 40px;
}

.el-button {
  width: 100%;
  height: 40px;
  border-radius: 20px;
}

.wanji {
  width: 60px;
  font-size: 12px;
  margin-top: 18px;
  color: #ababab;
  cursor: pointer;
}
.iconp {
  position: absolute;
  top: 5px;
  left: 10px;
  z-index: 10;
}
.xueming {
  margin: 36px 0 0 60px;
  font-size: 40px;
  color: #ffffff;
  letter-spacing: 3.08px;
}
.szjy {
  width: 350px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  letter-spacing: 1.23px;
}
.szjy_left {
  height: 0px;
  width: 60px;
  border: 1px solid #fff;
}
.szjy_content {
  font-size: 16px;
}
.szjy_right {
  height: 0px;
  width: 60px;
  border: 1px solid #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue